export default __webpack_public_path__ + "static/debit-card-side-1d799afc572cdc4dcdb950b9b6cdcc0b.png";